import React from 'react';
import './OpenHoursBanner.css';

function OpenHoursBanner() {
  return (
    <div className="open-hours-banner" data-aos="fade-up">

      <p>Open Everyday 7am–10pm</p>
    </div>
  );
}

export default OpenHoursBanner;
